import React from "react";
const CircleLine = ({ size = 100, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill={color}
  >
    <path d="M50 0c27.614238 0 50 22.385762 50 50s-22.385762 50-50 50S0 77.614238 0 50 22.385762 0 50 0zm0 24c-14.359403 0-26 11.640597-26 26s11.640597 26 26 26 26-11.640597 26-26-11.640597-26-26-26z" />
  </svg>
);
export default CircleLine;
